import axios from "axios";
import { urlBase } from "../../../../Constante/Url";
import { UserTockem } from "../../../../Utils/autenticacao";

const getConfig = (params) => {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
    params: params,
  };
};

const getPortabilidade = async (page, pageSize, id, params) => {
  const skip = (page - 1) * pageSize;
  const url = `${urlBase}portabilidade/?cartorio_id=${id}&limit=${pageSize}&offset=${skip}`;
  const config = getConfig(params);
  const response = await axios.get(url, config);
  return response;
};

export const portabilidadeRequest = {
  getPortabilidade,
};
